module.exports = __webpack_public_path__ + "img/Andrew_Li.7847ee8b.jpg";